/** @format */

import React, { useState } from 'react';
import {
  Grid,
  IconButton,
  Button,
  Typography,
  CardActions,
  Card,
  CardContent,
} from '@mui/material';
import { ButtonLoading, Icons, TableItemActionsNew, SimpleDialog } from 'components';
import { useNavigate } from 'react-router-dom';
import SubsetServices from '../../../../Subsets/services/SubsetServices';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';



export default function BranchItem({
  data,
  actionsList,
  refreshList,
}) {
  // --STATES--//

  // --HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();
  const [dialog, setDialog] = useState({});
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingBtnAccept, setLoadingBtnAccept] = useState(false);
  const [loadingBtnIgnore, setLoadingBtnIgnore] = useState(false);

  // -- LOCAL VARIABLES --//
  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={dialog?.onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  const changeStateOfBranch = async (selectedRow, changeStatusGroup) => {
    setLoadingBtn(true)
    if (changeStatusGroup) setLoadingBtnAccept(true);
    else setLoadingBtnIgnore(true);
    try {
      if (Array.isArray(selectedRow)) {
        const filterBaseOnSameState = selectedRow.filter(
          (row) => row?.branchInfoSrv?.enable !== changeStatusGroup,
        );

        if (filterBaseOnSameState.length) {
          await SubsetServices.changeStateOfBranch({
            branchId: filterBaseOnSameState.map((row) => row.id),
            enable: changeStatusGroup,
          });
        }
      } else {
        await SubsetServices.changeStateOfBranch({
          branchId: [selectedRow?.id],
          enable: !selectedRow?.branchInfoSrv?.enable,
        });
      }
      setTimeout(() => {
        refreshList()
      }, 100);
    } catch (error) {
    } finally {
      setLoadingBtnAccept(false);
      setLoadingBtnIgnore(false);
      handleCloseDialog();
      setLoadingBtn(false)

    }
  };
  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false, onAccept: () => null });
  };
  const ChangeStateGroupActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtnAccept}
          name="فعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, true)}
        />

        <ButtonLoading
          type="submit"
          variant="outlined"
          color="primary"
          loading={loadingBtnIgnore}
          name="غیرفعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, false)}
          className={classes.disabledRow}


        />

        <Button
          variant="contained"
          onClick={handleCloseDialog}
          style={{ marginLeft: '-8px!important' }}>
          انصراف
        </Button>
      </>
    );
  };

  return (
    <>
      <Card
        xs={12}
        className={clsx(classes.root, {
        })}
      >
        <CardContent
          className={clsx(classes.content, {
          })}
        >
          {/* Titles */}
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            className={classes.cardHeader}
          >
            <Grid item className={classes.titlePart}>
              <Typography variant="h5" className={classes.titleText}>
                {data?.name}
              </Typography>
              <Typography variant="h6" className={classes.subtitleText}>
                شناسه :   {data?.id ?? '-'}
              </Typography>
            </Grid>
            {actionsList['branchListOperationAction'] && (
              <Grid item className={classes.titleActions}>
                <IconButton
                  className={classes.actionsIcon}
                  onClick={() => navigate(`/Branch/${data.id}`, { state: data })}
                  size="large">
                  <Icons icon="Edit" color="#000" size="23" />
                </IconButton>
              </Grid>
            )}
          </Grid>

          <div className={classes.cardInside}>
            {/* Balances */}
            <Grid container justifyContent="space-between">
              <Grid item xs={12} md={6}>
                <Typography className={classes.balanceTitle}>مالک شعبه </Typography>
                <Typography className={classes.balanceMoney}>

                  <span>{data?.owner?.name || "-"}</span>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions className={classes.actionButtons}>
          <Grid container>
            {actionsList['branchListChargeBtn'] && (
              <ButtonLoading
                onClick={() => navigate(
                  `/transferToBranch?username=${data.username}&fullName=${data.name}+&userId=${data.userId}&userInfoType=username&userInfo=${data.username}&transferType=wallet`,
                )}
                size="small"
                className={classes.actionButton}
                name="شارژ شعبه"
              />
            )}


            {actionsList['branchListReportBtn'] && (
              <Button
                onClick={() => navigate(`/Branch/Transactions/${data.id}`, { state: { branchInfo: data } })}
                size="small"
                className={classes.actionButton}
              >
                گزارش صورتحساب
              </Button>
            )}
            {/* Other Actions */}
            {(actionsList['branchListOperationAction'] || actionsList['branchListDetailAction'] ||
              actionsList['branchListTransferAction']) && (
                <div className={classes.otherActions}>
                  <TableItemActionsNew
                    iconButton
                    startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />} title=""
                    otherMenus={[
                      {
                        title: 'عملیات مالی',
                        isShow: !!(actionsList['branchListTransferAction']),
                        isOpen: false,
                        id: 'FinancialOperation',
                        children: [

                          {
                            title: 'تفویض وجه',
                            onClick: () => navigate(`/DelegationToUser?username=${data.username}&Type=Branch`, { state: { branchInfo: data } }),
                          },
                          {
                            title: 'سقف مالی شعبه',
                            onClick: () => navigate(`/Branch/${data.id}/financial`, { state: data }),
                          },
                        ],
                      },

                      {
                        title: 'عملیات شعبه',
                        isShow: !!(actionsList['branchListOperationAction']),
                        isOpen: false,
                        id: 'operatin',
                        children: [
                          {
                            title: data?.branchInfoSrv?.enable ? 'غیرفعال‌سازی شعبه' : 'فعال‌سازی شعبه',
                            isShow: true,
                            onClick: () => {
                              setDialog({
                                title: data?.branchInfoSrv?.enable
                                  ? ` غیرفعال‌سازی شعبه ${data.name}`
                                  : ` فعال‌سازی شعبه ${data.name} `,
                                content: data?.branchInfoSrv?.enable ? 'با انجام این عملیات، شعبه/تنخواه گردان مورد نظر دیگر امکان برداشت وجه از حساب خود در پنل کسب و کار را نخواهد داشت. آیا از این تغییر مطمئن هستید؟' : 'آیا از انجام این عملیات اطمینان دارید؟',
                                open: true,
                                type: 'ChangeStateActionBtn',
                                onAccept: () => {
                                  changeStateOfBranch(data);
                                },
                              });
                            },
                          },
                        
                        ],
                      },

                      {
                        title: 'گزارشات',
                        isShow: !!(actionsList['branchListDetailAction']),
                        isOpen: false,
                        id: 'reports',
                        children: [
                          {
                            title: 'جزئيات',
                            onClick: () => navigate(`/Branch/${data.id}/detail`, { state: { branchInfo: data } }),
                          },


                        ],
                      },
                    ]}
                  />

                </div>
              )}
          </Grid>
        </CardActions>



      </Card>
      {dialog.type === 'ChangeStateActionBtn' && (
        <SimpleDialog
          title={dialog?.title}
          content={dialog?.content}
          open={dialog?.open || false}
          actions={<ChangeStateActionBtn />}
        />
      )}

      {dialog.type === 'ChangeStateGroupActionBtn' && (
        <SimpleDialog
          title={dialog?.title}
          content={dialog?.content}
          open={dialog?.open || false}
          actions={<ChangeStateGroupActionBtn />}
        />
      )}
    </>
  );
}

const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';
const green = '#508b46';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      // marginBottom: theme.spacing(2),
      boxShadow: 'none',
      border: '1px solid #A1AAE380',
      borderRadius: 10,
      background: '#A1AAE312',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '& .MuiCardContent-root': {
        padding: 0,
      },
      '&.disabled': {
        opacity: 0.5,
        // background: theme.palette.grey[200]
      },
    },
    infoIcon: {
      fontSize: '20px',
      marginBottom: theme.spacing(-0.8),
      marginInlineStart: theme.spacing(1),
      color: theme.palette.grey[800],
      cursor: 'pointer',
    },
    content: {
      position: 'relative',
      //paddingBottom: `${theme.spacing(0.5)} !important`,
      '&.disabled': {
        // background: theme.palette.grey[500]
      },
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',

      '@media(max-width: 550px)': {
        width: '80%'
      }
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'bold',
    },

    subtitleText: {
      fontSize: 13,
      color: '#A4A4A4',
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
      '& .MuiGrid-container': {
        '@media(max-width: 550px)': {
          gap: ' 8px',
        }

      }
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: 10,
      paddingInlineEnd: 10,
      marginInlineEnd: 6,
      borderRadius: 8,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      fontSize: '12PX',
      backgroundColor: '#ffffff',
      '@media(max-width: 550px)': {
        fontSize: 12,
        width: '48%',
        margin: '0',
        '&:nth-child(3)': {
          width: '99%',
        },

      },

    },
    balanceTitle: {
      fontSize: 14,
      color: '#A4A4A4',
      fontWeight: 'normal',
    },
    balanceMoney: {
      marginBottom: theme.spacing(2),
      fontSize: 14,
      color: '#2A2A2A',
      fontWeight: 'bold',
      '& span': {
        fontSize: 14,
        color: lightGray,
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(0),
      marginTop: theme.spacing(0),
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      padding: 0,
      "& svg": {
        "& path": {
          stroke: '#303d8f'

        }
      }

    },
    propertyContainer: {
      marginTop: theme.spacing(3),
      cursor: 'pointer',
      '&:hover p': {
        color: theme.palette.primary.main,
      },
      '&.disabled': {
        cursor: 'auto',
        '&:hover p': {
          color: 'initial',
        },
      },
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
      paddingTop: '5px',
      lineHeight: '34px',
      '@media(max-width: 550px)': {
        fontSize: 12,
        width: '100%',
        margin: '0',
        lineHeight: '40px',
        textAlign: 'right',
        paddingRight: '6px',
        '& .otherActions': {
          width: '33px',
        }

      },

      '& .MuiIconButton-root': {
        border: '2px solid #303d8f',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        padding: '0',
        marginRight: 3,
        '& svg': {
          fill: '#303d8f',
          transform: 'scale(0.8)'
        }
      },
      '& .MuiButton-text': {
        fontSize: 13,
        color: '#3a49a3',
        fontWeight: 'bold'
      }
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
    cardHeader: {
      padding: theme.spacing(2),
    },
    cardInside: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    expiredFlag: {
      background: ligherGray,
      borderBottomLeftRadius: 10,
      padding: theme.spacing(1, 2),
      paddingBottom: theme.spacing(1.5),
      // marginTop: theme.spacing(-2),
      // marginInlineEnd: theme.spacing(-2),
      color: '#455b64',
      fontSize: 13,
      position: 'absolute',
      right: 0,
      top: 0,
      fontWeight: 'bold',
    },

  };
});
